class FeaturedCategoriesSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.featured-categories-grid__slider');
    this.slides = this.querySelectorAll('.featured-categories-grid__slide');
    this.pagination = this.querySelector('.featured-categories-grid__pagination');
    this.dots = this.querySelectorAll('.pagination-dot');
    this.prevArrow = this.querySelector('.featured-categories-grid__arrow--prev');
    this.nextArrow = this.querySelector('.featured-categories-grid__arrow--next');

    this.currentSlide = 0;
    this.autoplayInterval = null;
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;
    this.autoplayEnabled = this.dataset.autoplay === 'true';

    if (this.slides.length > 0) {
      this.init();
    }
  }

  init() {
    // Set first slide as active
    this.slides[0].classList.add('active');
    if (this.dots.length > 0) {
      this.dots[0].classList.add('active');
    }

    // Add click event to pagination dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.resetAutoplay();
      });
    });

    // Add click event to arrow buttons
    if (this.prevArrow) {
      this.prevArrow.addEventListener('click', () => {
        this.previousSlide();
        this.resetAutoplay();
      });
    }

    if (this.nextArrow) {
      this.nextArrow.addEventListener('click', () => {
        this.nextSlide();
        this.resetAutoplay();
      });
    }

    // Start autoplay if enabled
    if (this.autoplayEnabled && this.slides.length > 1) {
      this.startAutoplay();
    }

    // Pause autoplay on hover
    this.addEventListener('mouseenter', () => {
      this.pauseAutoplay();
    });

    this.addEventListener('mouseleave', () => {
      if (this.autoplayEnabled) {
        this.startAutoplay();
      }
    });

    // Support for keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.previousSlide();
        this.resetAutoplay();
      } else if (e.key === 'ArrowRight') {
        this.nextSlide();
        this.resetAutoplay();
      }
    });

    // Make it focusable for keyboard navigation
    this.setAttribute('tabindex', '0');
  }

  goToSlide(index) {
    // Remove active class from current slide and dot
    this.slides[this.currentSlide].classList.remove('active');
    if (this.dots[this.currentSlide]) {
      this.dots[this.currentSlide].classList.remove('active');
    }

    // Set new current slide
    this.currentSlide = index;

    // Add active class to new slide and dot
    this.slides[this.currentSlide].classList.add('active');
    if (this.dots[this.currentSlide]) {
      this.dots[this.currentSlide].classList.add('active');
    }
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  previousSlide() {
    const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  startAutoplay() {
    this.pauseAutoplay(); // Clear any existing interval
    if (this.slides.length > 1) {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, this.autoplayDelay);
    }
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resetAutoplay() {
    if (this.autoplayEnabled) {
      this.pauseAutoplay();
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.pauseAutoplay();
  }
}

customElements.define('featured-categories-slider', FeaturedCategoriesSlider);
